<template lang="pug">
.description
  TwoColumnDataPanel(:obj="refugioData")
  .datos-container
    TwoColumnDataPanel(title="Instituciones cercanas")
    .datos-row.ticket-info-row
      .datos-column1
      .datos-column2
        TicketInfo(:link="getInstitucionLink(currentRefugio.id_comisaria)", icon="ap-Comisaria", :icon-invert-color="true")
          template(slot="values")
            div
              span.amount {{round(currentRefugio.distancia_comisaria) || '-'}}
              span.label  metros

        TicketInfo(:link="getInstitucionLink(currentRefugio.id_educacion)", icon="ap-Institucion-educativa", :icon-invert-color="true")
          template(slot="values")
            div
              span.amount {{round(currentRefugio.distancia_educacion) || '-'}}
              span.label  metros
        TicketInfo(:link="getInstitucionLink(currentRefugio.id_religion)", icon="ap-Institucion-religiosa", :icon-invert-color="true")
          template(slot="values")
            div
              span.amount {{round(currentRefugio.distancia_religion) || '-'}}
              span.label  metros
        TicketInfo(:link="getInstitucionLink(currentRefugio.id_salud)", icon="ap-Institucion-salud", :icon-invert-color="true")
          template(slot="values")
            div
              span.amount {{round(currentRefugio.distancia_salud) || '-'}}
              span.label  metros
  br

</template>

<script>
import { mapGetters } from 'vuex'
import { hasValue, clone, getData } from '@/utils/object.js'

export default {
  props: {
    refugio: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.cleanRefugioData()
  },
  data: () => ({
    refugioData: null
  }),
  methods: {
    round: Math.round,
    cleanRefugioData () {
      if (this.hasData) {
        const refugio = clone(this.currentRefugio)
        refugio.estado = refugio.estado || 'ACTIVO'
        const centroMunicipal = this.centroMunicipalById(refugio.centro_municipal)
        if (centroMunicipal) {
          refugio.centroMunicipal = {
            link: {
              name: 'map',
              query: {
                ver: 'refugios',
                centro_municipal_id: centroMunicipal.id
              }
            },
            text: centroMunicipal.centros_municipales
          }
        }
        const cantidadFamilias = this.getCantidadFamiliasInCensoByRefugioNro(refugio.nro)
        const cantidadPersonas = this.getCantidadPersonasInCensoByRefugioNro(refugio.nro)
        this.refugioData = {
          'Zona (bañado)': refugio.zona_banhado,
          'Centro Municipal': refugio.centroMunicipal,
          'Barrio': refugio.barrio,
          'Estado': refugio.estado,
          'Cantidad de familias censadas': cantidadFamilias || '-',
          'Cantidad de personas censadas': cantidadPersonas || '-'
        }
      }
    },
    getInstitucionLink (institucionId) {
      return {
        text: getData(this.getInstitucionById(institucionId)).institucion_afectada,
        to: {
          name: 'map',
          query: {
            ver: 'refugios',
            institucion_id: institucionId
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([ 'centroMunicipalById', 'getCantidadFamiliasInCensoByRefugioNro', 'getCantidadPersonasInCensoByRefugioNro', 'getInstitucionById' ]),
    ...mapGetters({ currentRef: 'currentRefugio' }),
    censo () {
      return getData(this.totalCenso)
    },
    hasData () {
      return hasValue(this.refugio)
    },
    currentRefugio () {
      return getData(this.currentRef)
    }
  },
  watch: {
    refugio (val) {
      if (val) this.cleanRefugioData()
    },
    currentRefugio (val) {
      if (hasValue(val)) this.cleanRefugioData()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-info-scoped'

$label-color = #878787
$circulo = $f65px
$semicirculo = ($circulo / 2)
$datos-sexos-height = $f32px

.description
  & >>>
    .mapper
      .flex.key, .flex.value
        font-size: $f17px

.datos-container
  margin-top: $f20px
  white-space: normal
  i
    color: $color_0
    margin: 0 $f5px 0 0

  .datos-row
    display: flex

  .datos-column1
    flex: 0 0 2%

  .datos-column2
    flex: 1 1 64%
    border-left: 2px solid $color_0

  .amount,
  .label
    color: $label-color
  .amount
    font-weight: bold

  .row1
    & .datos-column1
      flex: 1 1 36%
    & .datos-column2
      flex: 1 1 64%
    & .datos-column1,
    & .datos-column2
      display: flex
      justify-content: flex-start
      align-items: flex-end
      span
        flex: 1 1 70%
        max-height: $circulo
      .amount
        font-weight: bold
        font-size: $f38px
      .label
        font-size: $f10px

  .datos-column1
    &.familias
      position: relative
      .label
        font-weight: bold
      .ap-familias-estadisticas
        font-size: $f90px
        flex: 1 1 40%
      span
        border-right: 2px solid $color_0
        flex: 1 1 30%
        padding-right: $f3px

  .datos-column2
    &.sexos
      span
        border-left: 2px solid $color_0
        flex: 1 1 85%
        height: $circulo
        padding-left: $f4px
      span,
      .datos-sexos-info
        display: flex
        justify-content: space-between
        flex-direction: column
      .datos-sexos
        display: flex
        &.female
          margin-top: - $f10px
        &.male
          margin-bottom: - $f16px
      .datos-circulo-separator
        flex: 1 1 15%
      .datos-sexos-icon
        font-size: $datos-sexos-height
      .datos-sexos-info
        .amount
          font-size: $f20px
        .label
          font-size: $f10px

  .datos-circulo
    background-color: $color_0
    border-radius: 50%
    height: $circulo
    position: absolute
    width: $circulo
    color: white
    right: - ($semicirculo + $f1px)
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    font-weight: bold
    line-height: 1
    .number
      font-size: $f36px
    .asu-title
      margin-top: - $f5px
      font-size: $f11px

  .datos-circulo-separator
    flex: 1 1 30%
    height: $circulo
    .line
      background-color: $color_0
      height: $f2px
      width: 100%
</style>
